module.exports = __webpack_public_path__ + "img/super02.40b52d9d.png";